// extracted by mini-css-extract-plugin
export default {"tableWrapper":"UsersPage_tableWrapper__ulFdF","oddRow":"UsersPage_oddRow__6fvSy"};